<div class="square" [ngStyle]="styles">
    <div class="icon-wrapper">
      <img src="{{ this.IconImg }}" />
    </div>
    <div class="allText">
      <p class="numberText">
        {{ this.valor }}
      </p>
      <p>{{ this.titulo }}</p>
    </div>
  </div>